import React from "react";
import { DIVISIONS } from "../../../src/constants.js"
import DivisionalReportsPage from "./DivisionalReportsPage.js";

export default function RecreationalReports() {
  return <DivisionalReportsPage division={DIVISIONS.RECREATIONAL}/>
};